import React from "react";

import Button from "components/button";
import HelpGraphic from "../helpGraphic/helpGraphic";
import styles from "./helpCard.scss";

const { help_card, help_card_inside } = styles;

function HelpCard({ onNeedhelpClick }) {
  return (
    <div className={help_card}>
      <div className={help_card_inside}>
        <HelpGraphic />
        <h4>Need Support?</h4>
        <h5>Connect with Airtel Representative</h5>
        <Button onClick={onNeedhelpClick} displayName="View Contacts" variant="small_outlinebtn"></Button>
      </div>
    </div>
  );
}

export default HelpCard;
